import React, { useRef, useEffect } from 'react';
// import { getRandomBetween, getRandomFromArray, getRandomIntBetween } from "../../core/helpers";
import bubbles from './bubbles';

const ALPHA_MAX = 200;
const ALPHA_STEP = 0.25;

function GlowingBubbles() {
    const bg = useRef(null);

    useEffect(() => {
        let animationId;
        let mouseX = 0, mouseY = 0;
        const ctx = bg.current.getContext('2d');
        bg.current.width = window.innerWidth;
        bg.current.height = window.innerHeight;
        // const bubbles = generateBubbles(100);
        // console.log(JSON.stringify(bubbles));

        // window.addEventListener('mousemove', (event) => {
        //     const { x, y } = event;
        //     mouseX = x;
        //     mouseY = y;
        // });

        function tickAnimation() {
            ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
            bubbles.forEach((bubble, index) => {
                const {
                    x,
                    y,
                    radius,
                    alpha,
                    alphaDirection,
                    color,
                    depth,
                    xMove,
                    xMoveDirection
                } = bubble;
                const xWithMove = x + ((window.innerWidth/2 - mouseX)/window.innerWidth)*depth + xMove;
                const yWithMove = y + ((window.innerHeight/2 - mouseY)/window.innerHeight)*depth;
                const exactAlpha = Math.max(0, alpha - 50)/1000;
                ctx.globalAlpha = exactAlpha;
                const fill = ctx.createRadialGradient(
                    xWithMove,
                    yWithMove,
                    0,
                    xWithMove,
                    yWithMove,
                    radius
                );
                fill.addColorStop(0, color);
                fill.addColorStop(1 - 5*((ALPHA_MAX - 50)/1000 - exactAlpha), color);
                fill.addColorStop(1, 'transparent');
                ctx.fillStyle = fill;
                ctx.beginPath();
                ctx.arc(xWithMove, yWithMove, radius, 0, 2 * Math.PI);
                ctx.fill();
                ctx.closePath();
                if ((alpha >= ALPHA_MAX && alphaDirection === 1) || (alpha <= 0 && alphaDirection === -1)) {
                    bubble.alphaDirection = -alphaDirection;
                } else {
                    bubble.alpha = alpha + ALPHA_STEP * alphaDirection;
                }
                if ((xMove >= 50 && xMoveDirection === 1) || (xMove <= 0 && xMoveDirection === -1)) {
                    bubble.xMoveDirection = -xMoveDirection;
                } else {
                    bubble.xMove = xMove + 0.1 * xMoveDirection;
                }
            });

            animationId = requestAnimationFrame(tickAnimation);
        }

        animationId = requestAnimationFrame(tickAnimation);
        return () => {
            cancelAnimationFrame(animationId);
        };
    }, [bg]);

    return (
        <canvas
            ref={bg}
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                // filter: 'blur(3px)',
            }}/>
    );
}

// const colors = [
//     '#e53935',
//     // '#7e57c2',
//     '#ff8f00',
//     '#ffca28',
//     // '#43a047',
//     '#ec407a',
//     // '#00bcd4',
//     // '#42a5f5',
// ];
//
// function generateBubbles(count) {
//     return (new Array(count)).fill({}).map(() => {
//         const radius = getRandomBetween(30, 40);
//         const alpha = getRandomIntBetween(0, ALPHA_MAX);
//         const x = Math.random() * window.innerWidth;
//         const y = getRandomBetween(100, window.innerHeight - 100);
//         const alphaDirection = getRandomFromArray([-1, 1]);
//         const color = getRandomFromArray(colors);
//         const depth = getRandomIntBetween(0, 40);
//         const xMove = getRandomBetween(1, 50);
//         const xMoveDirection = getRandomFromArray([-1, 1]);
//
//         return {
//             x,
//             y,
//             radius,
//             alpha,
//             alphaDirection,
//             color,
//             depth,
//             xMove,
//             xMoveDirection,
//         };
//     });
// }

export default GlowingBubbles;